'use client';

import { ReactNode } from 'react';

import {
  Box,
  Grid,
  PageHeading,
  RadioGroup,
  SectionTab,
  Typography,
} from '@/primitives';

export interface Step {
  title: ReactNode;
  subTitle: ReactNode;
  value: string;
  completed?: boolean;
}

export interface StepsPanelProps {
  children: ReactNode;
  currentStep: string;
  header?: ReactNode;
  steps: Step[];
  subTitle: ReactNode;
  title: ReactNode;
}

export function MultiStepLayout({
  children,
  currentStep,
  header,
  steps,
  subTitle,
  title,
}: StepsPanelProps) {
  return (
    <Grid container spacing="24px">
      <Grid size={{ xs: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '0 24px 24px',
            }}
          >
            {header}
            <PageHeading>{title}</PageHeading>
            <Typography variant="bodymedium" color="text.secondary">
              {subTitle}
            </Typography>
          </Box>
          <RadioGroup
            value={currentStep}
            sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            {steps.map((step, index) => {
              return (
                <SectionTab
                  key={step.value}
                  title={
                    <>
                      {index + 1}. {step.title}
                    </>
                  }
                  subTitle={step.subTitle}
                  value={step.value}
                  completed={
                    currentStep === step.value ? false : step.completed
                  }
                />
              );
            })}
          </RadioGroup>
        </Box>
      </Grid>
      <Grid size={{ xs: 9 }}>{children}</Grid>
    </Grid>
  );
}
